import type { ReactNode } from 'react'

import { TEST_ID } from '@/src/general/constants/testId'
import type { TWithBrowserTextareaHeightProps } from '@/src/general/utils/withBrowserTextareaHeight'
import { useTranslate } from '@/src/lang/useTranslate'

import { useCreateIntentionMutation } from '../../../services/useCreateIntentionMutation'
import { IntentionFormCtaBlock, type TIntentionFormCtaBlockProps } from '../IntentionFormCtaBlock'

export type TIntentionFormProps = Partial<
  Pick<TIntentionFormCtaBlockProps, 'title' | 'description' | 'testID' | 'onDisplay' | 'onSubmit' | 'ref'>
>

export const IntentionForm = ({
  testID,
  title,
  onSubmit,
  ref,
  ...otherProps
}: TIntentionFormProps & Partial<TWithBrowserTextareaHeightProps>): ReactNode => {
  const { t } = useTranslate()

  const { isSuccess, isPending, error, mutate } = useCreateIntentionMutation()

  return (
    <IntentionFormCtaBlock
      ref={ref}
      testID={testID ?? TEST_ID.INTENTION.FORM.INPUT}
      title={isSuccess ? t('pray.your-intention') : (title ?? t('pray.write-intention'))}
      successMessage={isSuccess && t('pray.prayer-sent')}
      placeholder={t('pray.your-intention')}
      onSubmit={(content) => {
        mutate(content)
        onSubmit?.(content)
      }}
      button={{ testID: TEST_ID.INTENTION.FORM.SUBMIT_BUTTON }}
      maxLength={160}
      error={error}
      isPending={isPending}
      isSuccess={isSuccess}
      {...otherProps}
    />
  )
}
